const EnumTipoAtendimento = {
    HORA_MARCADA: 'HORA_MARCADA',
    ORDEM_DE_CHEGADA: 'ORDEM_DE_CHEGADA'
};

export default EnumTipoAtendimento;
